// VIGÍA DE LA ENTRADA DE PLATFORM ADMIN ("Entrar" / "Ver como").
//
// Lissette, 2026-10-26: escribía el motivo, la página se recargaba y volvía a
// Platform Admin. El aviso E3 dijo que la entrada guardada había desaparecido
// al recargar, y en el código no hay nada que la borre sin dejar nota. En vez
// de seguir adivinando, esto mira dos cosas desde el PRIMER instante de la
// página (se importa antes que todo en main.jsx):
//
//   1. Si la entrada estaba guardada al arrancar (`alArrancar`). Si no estaba,
//      la escritura se perdió ANTES de recargar, no la borró nadie después.
//   2. Si algo la BORRA (removeItem / clear sobre localStorage): se anota
//      quién, con tres líneas de la pila, en `deskte:entradaPerdida`.
//
// Platform Admin enseña ese dato en el aviso (diagnosticoDeEntrada). No cambia
// el comportamiento de nada: solo mira y anota.

const VIGILADAS = new Set(['deskte:impersonateAgencyId', 'deskte:impersonateUserId']);
const NOTA = 'deskte:entradaPerdida';

export const alArrancar = (() => {
  try {
    // En los dos sitios donde puede estar (ver entradaGuardada.js): localStorage
    // y el respaldo de la pestaña.
    const en = (k) => !!(localStorage.getItem(k) || sessionStorage.getItem(k));
    return {
      agencia: en('deskte:impersonateAgencyId'),
      usuario: en('deskte:impersonateUserId'),
    };
  } catch (_) { return { agencia: false, usuario: false }; }
})();

/** Las tres líneas de la pila de quien llamó (sin el vigía), cortas. */
export function quienLlama(pila) {
  return String(pila || '')
    .split('\n')
    .map((l) => l.trim())
    .filter((l) => l && !/^Error\b/.test(l))
    // La primera línea es siempre el propio vigía (donde se crea el Error):
    // se salta, y quedan las tres de quien de verdad llamó.
    .slice(1, 4)
    .map((l) => l.replace(/^at\s+/, '').replace(/https?:\/\/[^/]+\//g, '').slice(0, 90))
    .join(' | ');
}

function anotar(texto) {
  try {
    if (!localStorage.getItem(NOTA)) localStorage.setItem(NOTA, texto.slice(0, 300));
  } catch (_) { /* nada que hacer */ }
}

export function instalarVigiaDeEntrada() {
  try {
    if (typeof Storage === 'undefined' || Storage.prototype.__vigiaEntrada) return;
    const quitar = Storage.prototype.removeItem;
    const vaciar = Storage.prototype.clear;
    Storage.prototype.removeItem = function removeItemVigilado(clave) {
      try {
        if (this === window.localStorage && VIGILADAS.has(clave) && this.getItem(clave)) {
          anotar(`quitada:${clave.replace('deskte:impersonate', '')} ${quienLlama(new Error().stack)}`);
        }
      } catch (_) { /* nunca estorbar */ }
      return quitar.call(this, clave);
    };
    Storage.prototype.clear = function clearVigilado() {
      try {
        if (this === window.localStorage
          && (this.getItem('deskte:impersonateAgencyId') || this.getItem('deskte:impersonateUserId'))) {
          anotar(`vaciado ${quienLlama(new Error().stack)}`);
        }
      } catch (_) { /* nunca estorbar */ }
      return vaciar.call(this);
    };
    Storage.prototype.__vigiaEntrada = true;
  } catch (_) { /* sin vigía, la app sigue igual */ }
}

instalarVigiaDeEntrada();
